import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Route } from 'react-router-dom';

// Components
import Header from '../components/header/headerCommon/HeaderCommon.jsx';
import Sidebar from '../components/sidebar/Sidebar.jsx';

// Context
import { HeaderContext } from '../context/HeaderContext.jsx';

// Styles
import '../components/sidebar/Sidebar.scss';

const PrivateRoute = (props) => {
  const { component, path, pageName, hideHeader, hideSidebar } = props;
  const location = useLocation();
  // States
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const { setTitle, setSubTitle, setSubtitleStyle } = useContext(HeaderContext);

  const updatePageName = location.state && location.state.pageName ? location.state.pageName : pageName;

  useEffect(() => {
    setTitle(undefined);
    setSubTitle(undefined);
    setSubtitleStyle(null);
  }, [location.pathname, setTitle, setSubTitle, setSubtitleStyle]);

  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <div className="app dashboardContainer">
      {!hideSidebar && (
        <Sidebar
          collapsed={collapsed}
          toggled={toggled}
          handleToggleSidebar={setToggled}
          handleCollapsedChange={setCollapsed}
        />
      )}
      <main className="dashboard">
        <div id="floating-logo-root" style={{ position: 'relative' }} />
        {!hideHeader && <Header pageName={updatePageName} />}
        <section className="homeSection">
          <Route component={component} path={path} exact />
        </section>
      </main>
    </div>
  );
};

export default PrivateRoute;
